import * as React from 'react';
import {MockupList} from '../../../../node_modules/argo-ui';

export const Loading = () => <MockupList />;
